import { forwardRef } from 'react'
import styled from 'styled-components'

import Header from './Header'
import Content from './Content'
import Footer from './Footer'
import Awards from './Awards'
import AnotherLanguage from 'components/Common/AnotherLanguage'
import { Product } from 'api/schemas'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: var(--typography-normal);
  word-break: break-word;
  overflow-wrap: break-word;
`
interface ITechListProps {
  lng: string
  product: Product
}
const TechListPrint = forwardRef<HTMLInputElement, ITechListProps>(
  ({ product, lng }, ref) => {
    return (
      <AnotherLanguage lng={lng}>
        <Wrapper ref={ref}>
          <Header product={product} />
          <Content product={product} />
          <Awards product={product} />
          <Footer product={product} />
        </Wrapper>
      </AnotherLanguage>
    )
  }
)

export default TechListPrint
